import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=4904fb84&scoped=true"
import script from "./company-info.vue?vue&type=script&lang=js"
export * from "./company-info.vue?vue&type=script&lang=js"
import style0 from "./company-info.vue?vue&type=style&index=0&id=4904fb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904fb84",
  null
  
)

export default component.exports